import { TeilnehmerVO } from "@core/api/v1";
import BundeslandEnum = TeilnehmerVO.BundeslandEnum;

export const bundeslandOptionen: { label: string, value: BundeslandEnum }[] = [
    {label: 'Burgenland', value: BundeslandEnum.BURGENLAND },
    {label: 'Kärnten', value: BundeslandEnum.KAERNTEN },
    {label: 'Niederösterreich', value: BundeslandEnum.NIEDEROESTERREICH },
    {label: 'Oberösterreich', value: BundeslandEnum.OBEROESTERREICH },
    {label: 'Salzburg', value: BundeslandEnum.SALZBURG },
    {label: 'Steiermark', value: BundeslandEnum.STEIERMARK },
    {label: 'Tirol', value: BundeslandEnum.TIROL },
    {label: 'Vorarlberg', value: BundeslandEnum.VORARLBERG },
    {label: 'Wien', value: BundeslandEnum.WIEN }
];
